import React, { PureComponent } from 'react';
import Viewer from 'viewerjs';

require('viewerjs/dist/viewer.min.css');

class ImageListRender extends PureComponent<any> {
    imageListWrapper = React.createRef<HTMLDivElement>();

    viewer: any;

    render() {
        const { imageUrls } = this.props;
        return (
            <div style={{ display: 'none' }} ref={this.imageListWrapper}>
                {imageUrls.map((url: any, index: number) => {
                    return <img src={url} key={index} style={{ display: 'none' }} alt="" />;
                })}
            </div>
        );
    }

    componentDidMount() {
        const { index, hide, options: customOptions } = this.props;
        const { toolbar: customToolbar, hidden, ...restOptions } = customOptions || { toolbar: {} };
        const options = {
            toolbar: {
                zoomIn: true,
                zoomOut: true,
                oneToOne: true,
                reset: true,
                prev: true,
                play: true,
                next: true,
                rotateLeft: true,
                rotateRight: 4,
                flipHorizontal: true,
                flipVertical: true,
                ...customToolbar,
            },
            navbar: false,
            ...restOptions,
            hidden: () => {
                hidden && hidden();
                hide();
            },
        };
        this.viewer = new Viewer(this.imageListWrapper.current as Element, options);
        this.viewer?.view(index);
    }

    componentWillUnmount() {
        this.viewer.destroy();
    }
}
export default ImageListRender;
